import { makeRequest } from "@/util";
import { ConsentManagementConfigVersion, updateQuery } from "@/api";

import { ConsentManagerConfigSchema } from "../components/ConfigPage/ConsentManagerConfigForm/schema";

/** Omitted fields keep their saved value; sent fields replace it wholesale. */
type UpdateConsentManagementConfigVersionRequest = Pick<
  ConsentManagerConfigSchema,
  "type"
> &
  Partial<ConsentManagerConfigSchema>;

type UpdateConsentManagementConfigVersionResponse =
  ConsentManagementConfigVersion;

export async function updateConsentManagementConfigVersion(
  payload: UpdateConsentManagementConfigVersionRequest,
) {
  const res = await makeRequest<UpdateConsentManagementConfigVersionResponse>(
    "update_consent_management_config_version",
    payload,
  );

  updateQuery(
    ["get_consent_management_config_versions", { type: payload.type }],
    (existingData) => {
      if (!existingData) return null;

      let found = false;
      const updatedVersions = existingData.versions.map((version) => {
        if (version.id === res.data.id) {
          found = true;
          return res.data;
        }

        return version;
      });
      if (!found) {
        updatedVersions.unshift(res.data);
      }

      return {
        versions: updatedVersions,
      };
    },
  );
}
